import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ExposureZeroIcon(props: IconProps) {
    return <Icon {...props} iconKey={"exposure_zero"}/>
}
